import React, { Component, createRef } from 'react';
import 'flatpickr/dist/themes/light.css';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { english } from 'flatpickr/dist/l10n/default';
import Flatpickr from 'react-flatpickr';
import { IDatetimePicker } from '../../../models/components/input-date-time';
import Translator from '../../../core/i18n';
import Moment from 'moment';
import { string } from 'prop-types';
import flatpickr from 'flatpickr';
import { Log } from 'ng2-logger';

const _logger = Log.create('inputdatimetime.tsx');
const T = Translator.create();
const myFlatPicker = Flatpickr;
// let inputId = 'dateInput2';
export class DatetimeInput extends React.Component<IDatetimePicker> {

    public picker: HTMLInputElement | null = null;
    public validateDiv: HTMLDivElement | null = null;
    public inputIds: string[] = [];
    public state = {
        value: (this.props.value) ? this.props.value : '',
        onComplate: false
    };

    constructor(props: any) {
        super(props);
    }


    public onChange = (event: any) => {

        if (this.props.onChange) {
            this.props.onChange(event);
        }
        if (this.props.dateFormat) {
            let inputTime = (typeof event === 'object') ? Moment(event[0]) : Moment(event, this.props.dateFormat);
            if (inputTime.format('HH:mm:ss') === '00:00:00') {
                inputTime = inputTime.set({ second: 1 });
            }
            const timeToStr = Moment(inputTime).format(this.props.dateFormat);
            this.setState({ value: timeToStr });
        } else {
            this.setState({ value: event.target.value });
        }
        this.validate();
    }

    public onComplated = (status: any) => {
        if (this.props.onComplated) {
            this.props.onComplated(status);
        }
    }

    public onKeyUp = () => {
        this.validate();
    };

    public onChangeInput = (event: any) => {

        const regex = new RegExp('^([0-1]?[0-9]|2[0-3]):[0-5]?[0-9]:[0-5]?[0-9]$');

        if (regex.test(event.target.value) || !this.props.timeFormat) {
            let inputTime = Moment(event.target.value, 'HH:mm:ss', true);

            if (inputTime.isValid() && inputTime.format('HH:mm:ss') === '00:00:00') {
                inputTime = inputTime.set({ second: 1 });
            }

            const formattedTime = inputTime.isValid() ? inputTime.format('HH:mm:ss') : event.target.value;

            if (this.props.onChange) {
                this.props.onChange(formattedTime);
            }
            this.setState({ value: formattedTime });
        }

    }


    public componentDidMount = () => {
        this.setFlatPicker(this.props.datePickerId);

    }

    public componentDidUpdate = () => {
        this.setFlatPicker(this.props.datePickerId);
    }

    public setFlatPicker = (inputid: string) => {
        if (this.picker) {
            flatpickr('#' + inputid, {
                minDate: (this.props.minDate) ? this.props.minDate : '',
                maxDate: (this.props.maxDate) ? this.props.maxDate : '',
                maxTime: this.props.maxTime ?? '',
                minTime: this.props.minTime ?? '',
                enableSeconds: this.props.enableSeconds,
                time_24hr: (this.props.time24Hr !== undefined) ? this.props.time24Hr : true,
                locale: (T.i18next.language === 'tr') ? Turkish : english,
                dateFormat:
                    (this.props.mode !== 'time' && !this.props.enableTime) ? 'd.m.Y' :
                        (this.props.mode !== 'time' && this.props.enableTime) ? 'd.m.Y H:i' :
                            (this.props.mode === 'time') ? (this.props.enableSeconds) ? 'H:i:S' : 'H:i' : '',
                mode: (this.props.mode) ? this.props.mode : 'single',
                allowInput: true,
                clickOpens: true,
                enableTime: (this.props.enableTime) ? this.props.enableTime : (this.props.mode === 'time') ? true : false,
                defaultDate: this.state.value,
                onChange: e => { this.onChange(e); }

            });
        }
    }

    public validate = () => {
        if (this.picker) {

            const maxTimeMoment = Moment(this.props.maxTime, "HH:mm:ss", true);
            const currentTimeMoment = Moment(this.props.value, "HH:mm:ss", true);

            if (!currentTimeMoment.isValid()) {
                this.showValidationError(T.t('r_componenet_input_valid_format'));
            } else if (currentTimeMoment.isAfter(maxTimeMoment)) {
                this.showValidationError(T.t('r_componenet_input_valid_time'));
            } else if (this.picker.value === '') {
                this.showValidationError(T.t('r_componenet_input_required_message'));
            } else {
                this.showValidationSuccess(T.t('r_componenet_input_valid_message'));
            }

        }
    }

    private showValidationError(message: string) {
        if (this.validateDiv) {
            this.validateDiv.classList.remove('success');
            this.validateDiv.classList.add('error');
            this.validateDiv.innerHTML = message;
            this.onComplated(false);
        }
    }

    private showValidationSuccess(message: string) {
        if (this.validateDiv) {
            this.validateDiv.classList.remove('error');
            this.validateDiv.classList.add('success');
            this.validateDiv.innerHTML = message;
            this.onComplated(true);
        }
    }

    public render() {
        return (
            <div className="form-input form-group date-picker" >
                <input
                    onInvalid={this.validate}
                    ref={e => this.picker = e}
                    onKeyUp={this.onKeyUp}
                    id={this.props.datePickerId}
                    onChange={this.onChangeInput}
                    pattern={
                        (this.props.mode !== 'time' && !this.props.enableTime) ? (this.props.pattern) ? this.props.pattern : '[0-9]{2}.[0-9]{2}.[0-9]{4}' :
                            (this.props.mode !== 'time' && this.props.enableTime) ? (this.props.pattern) ? this.props.pattern : '[0-9]{2}.[0-9]{2}.[0-9]{4} [0-9]{2}:[0-9]{2}' :
                                (this.props.mode === 'time') ? (this.props.pattern) ? this.props.pattern : '[0-9]{2}:[0-9]{2}' : ''
                    }
                    value={this.state.value}
                    multiple={true}
                    required={(this.props.required) ? this.props.required : false}
                />
                <span className="highlight" />
                <span className="bar" />
                <label>{(this.props.placeHolder) ? this.props.placeHolder : ''}</label>
                <div style={{ position: 'absolute' }} ref={e => this.validateDiv = e} className="" />
            </div>
        );
    }
}
